import React from 'react';
import PropTypes from 'prop-types';
import { FormattedDate } from 'react-intl';

export const Gr8piFormattedDateTime = ({ dateValue }) => {
  return <FormattedDate year="numeric" month="short" day="2-digit" hour="numeric" minute="numeric" value={dateValue} />;
};

Gr8piFormattedDateTime.propTypes = {
  dateValue: PropTypes.string,
};

Gr8piFormattedDateTime.defaultProps = {
  dateValue: '',
};

export const Gr8piFormattedDate = ({ dateValue }) => {
  return <FormattedDate year="numeric" month="short" day="2-digit" value={dateValue} />;
};

Gr8piFormattedDate.propTypes = {
  dateValue: PropTypes.string,
};

Gr8piFormattedDate.defaultProps = {
  dateValue: '',
};
